export const FIELD_TYPES = {
  TEXT_FIELD: "text-field",
  SELECT_FIELD: "input-select",
  SELECT_DATE_FIELD: "input-select-date",
  DATE_FIELD: "date-field"
};

// Filters whose backend search supports several values in one filter (OR across the values).
// Separate chips of the same filter are separate backend filters (AND).
export const MULTI_SELECT_FILTER_IDS = [
  "Qualification",
  "Identification",
  "Tags",
  "Status",
  "WorkedAtSites",
  "SiteOfInterest",
  "DrivingLicenceCapability"
];

// Text filters that can collect several values in one add (OR across the values).
export const MULTI_TEXT_FILTER_IDS = ["AddressPostCode"];

export const trueFalseOptions = [
  {
    Name: "True",
    ObjectId: "true"
  },
  {
    Name: "False",
    ObjectId: "false"
  }
];

export const contactTypeOptions = [
  {
    Name: "Email",
    ObjectId: "Email"
  },
  {
    Name: "Phone",
    ObjectId: "Phone"
  },
  {
    Name: "Address",
    ObjectId: "Address"
  }
];

export const CANDIDATE_STATUS = [
  { Name: "Unprocessed", ObjectId: "Unprocessed" },
  { Name: "Processed", ObjectId: "Processed" },
  { Name: "DoNotUse", ObjectId: "DoNotUse" },
  { Name: "Inactive", ObjectId: "Inactive" },
  { Name: "Active", ObjectId: "Active" }
];
